<template>
    <div :class="{ content: $isMobileDevice }">
        <common-block
            :title="articleDetail.title"
            :content="articleDetail.content"
        />
    </div>
</template>
<script>
import CommonBlock from './components';
import { mapState } from 'vuex';
export default {
    components: { CommonBlock },
    computed: {
        ...mapState({
            articleDetail: state => state.footer.articleDetail
        })
    },
    watch: {
        $route: {
            handler(route) {
                if (route.query.id) {
                    this.$store.dispatch(
                        'footer/getArticleDetail',
                        route.query.id
                    );
                }
            },
            immediate: true
        }
    },
    created() {}
};
</script>
<style lang="scss" scoped>
.content {
    background: #fff;
    min-height: 100vh;
}
</style>
